import React from 'react'
import classNames from 'classnames'

import './styles.css'

const LargeText = ({ align, children, mb4 }) => {
  return (
    <p
      className={classNames({
        'mt0 f8 f7-m f6-l fw3 last-child-mb0 lh-large-text': true,
        'mb4 mb5-m': !mb4,
        mb4,
        'tc': align === 'center',
        'tr': align === 'right',
        'tl': align === 'left'
      })}
    >
      {children}
    </p>
  )
}

LargeText.defaultProps = {
  align: 'center'
}

export default LargeText



// WEBPACK FOOTER //
// ./src/components/large-text/large-text.js